<template>
  <section id="faq" class="bg-gray-50 py-24 sm:py-32" aria-labelledby="faq-heading" data-section-name="FAQ">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="mx-auto max-w-4xl">
        <header class="text-center">
          <h2 id="faq-heading" class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Frequently Asked Questions
          </h2>
          <p class="mt-6 text-lg leading-8 text-gray-600">
            Everything you need to know about PDFGen API
          </p>
        </header>
        
        <dl class="mt-16 space-y-8">
          <div v-for="faq in faqs" :key="faq.id" class="border-b border-gray-200 pb-8">
            <dt class="text-lg font-semibold leading-7 text-gray-900">
              {{ faq.question }}
            </dt>
            <dd class="mt-4 text-base leading-7 text-gray-600">
              {{ faq.answer }}
            </dd>
          </div>
        </dl>
      </div>
    </div>
    

  </section>
</template>

<script setup lang="ts">
const faqs = [
  {
    id: 1,
    question: "What is PDFGen?",
    answer: "PDFGen is a fast, developer-friendly API service that converts HTML content or URLs into high-quality PDF documents. It's perfect for generating reports, invoices, receipts, and other business documents programmatically."
  },
  {
    id: 2,
    question: "How does PDFGen work?",
    answer: "PDFGen works by accepting HTML content or URLs through a simple REST API. Our service processes the input and returns a high-quality PDF document. You can track the conversion process in real-time through our job tracking system."
  },
  {
    id: 3,
    question: "What formats does PDFGen support?",
    answer: "PDFGen supports HTML content (raw HTML strings) and public URLs. The output is always a high-quality PDF document. We handle CSS styling, images, and complex layouts automatically."
  },
  {
    id: 4,
    question: "Is PDFGen suitable for production use?",
    answer: "Yes, PDFGen is built for production use with high scalability, reliability, and performance. Our infrastructure can handle thousands of PDF generation requests with consistent quality and speed."
  },
  {
    id: 5,
    question: "How fast is PDF generation?",
    answer: "PDFGen is optimized for speed. Most PDF conversions complete within seconds, depending on the complexity of the content. Our real-time tracking system keeps you informed of the progress."
  },
  {
    id: 6,
    question: "What are the main use cases for PDFGen?",
    answer: "PDFGen is perfect for generating invoices, reports, receipts, contracts, certificates, marketing materials, and any other business documents that need to be converted from HTML to PDF format."
  },
  {
    id: 7,
    question: "How do I get started with PDFGen?",
    answer: "Getting started is simple! Join our early access program by signing up with your email. Once launched, you'll receive API credentials and comprehensive documentation to integrate PDFGen into your application."
  },
  {
    id: 8,
    question: "Is there documentation available?",
    answer: "Yes, we provide comprehensive documentation with code examples, API reference, and integration guides. The documentation will be available when we launch the service."
  }
];
</script> 